import { NSARouterMakerResult } from "namirasoft-account-react";
import { NSMenuActionProps } from "namirasoft-site-react";
import { TicketRow, TicketStatus } from "namirasoft-support";
import { SupportProps } from "./SupportProps";

export class SupportMenus
{
	static TicketResolve(getIDs: () => string[], getRows: () => TicketRow[], props: NSARouterMakerResult & SupportProps, callback?: () => void): NSMenuActionProps
	{
		return {
			id: "1",
			menu_item: "Resolve",
			isActive: () =>
			{
				if (getIDs().length === 1)
				{
					let ticket = getRows()[0];
					if (ticket)
						return ticket.status !== TicketStatus.Resolved;
				}
				return false;
			},
			onClick: {
				action: async (onFinish) =>
				{
					let ids = getIDs();
					if (ids.length === 1)
						props.servers.support.ticket.Resolved(ids[0]).then(() =>
						{
							props.notifier.onSuccess("The ticket has been successfully resolved.");
							callback?.();
							onFinish();
						}).catch(onFinish);

				},
			}
		};
	}
}